//#region ../../node_modules/.pnpm/tinycolor2@1.6.0/node_modules/tinycolor2/esm/tinycolor.js
function e(t) {
	"@babel/helpers - typeof";
	return e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
		return typeof e;
	} : function(e) {
		return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
	}, e(t);
}
var t = /^\s+/, n = /\s+$/;
function r(e, t) {
	if (e ||= "", t ||= {}, e instanceof r) return e;
	if (!(this instanceof r)) return new r(e, t);
	var n = i(e);
	this._originalInput = e, this._r = n.r, this._g = n.g, this._b = n.b, this._a = n.a, this._roundA = Math.round(100 * this._a) / 100, this._format = t.format || n.format, this._gradientType = t.gradientType, this._r < 1 && (this._r = Math.round(this._r)), this._g < 1 && (this._g = Math.round(this._g)), this._b < 1 && (this._b = Math.round(this._b)), this._ok = n.ok;
}
r.prototype = {
	isDark: function() {
		return this.getBrightness() < 128;
	},
	isLight: function() {
		return !this.isDark();
	},
	isValid: function() {
		return this._ok;
	},
	getOriginalInput: function() {
		return this._originalInput;
	},
	getFormat: function() {
		return this._format;
	},
	getAlpha: function() {
		return this._a;
	},
	getBrightness: function() {
		var e = this.toRgb();
		return (e.r * 299 + e.g * 587 + e.b * 114) / 1e3;
	},
	getLuminance: function() {
		var e = this.toRgb(), t = e.r / 255, n = e.g / 255, r = e.b / 255, i = t <= .03928 ? t / 12.92 : ((t + .055) / 1.055) ** 2.4, a = n <= .03928 ? n / 12.92 : ((n + .055) / 1.055) ** 2.4, o = r <= .03928 ? r / 12.92 : ((r + .055) / 1.055) ** 2.4;
		return .2126 * i + .7152 * a + .0722 * o;
	},
	setAlpha: function(e) {
		return this._a = O(e), this._roundA = Math.round(100 * this._a) / 100, this;
	},
	toHsv: function() {
		var e = c(this._r, this._g, this._b);
		return {
			h: e.h * 360,
			s: e.s,
			v: e.v,
			a: this._a
		};
	},
	toHsvString: function() {
		var e = c(this._r, this._g, this._b), t = Math.round(e.h * 360), n = Math.round(e.s * 100), r = Math.round(e.v * 100);
		return this._a == 1 ? "hsv(" + t + ", " + n + "%, " + r + "%)" : "hsva(" + t + ", " + n + "%, " + r + "%, " + this._roundA + ")";
	},
	toHsl: function() {
		var e = o(this._r, this._g, this._b);
		return {
			h: e.h * 360,
			s: e.s,
			l: e.l,
			a: this._a
		};
	},
	toHslString: function() {
		var e = o(this._r, this._g, this._b), t = Math.round(e.h * 360), n = Math.round(e.s * 100), r = Math.round(e.l * 100);
		return this._a == 1 ? "hsl(" + t + ", " + n + "%, " + r + "%)" : "hsla(" + t + ", " + n + "%, " + r + "%, " + this._roundA + ")";
	},
	toHex: function(e) {
		return u(this._r, this._g, this._b, e);
	},
	toHexString: function(e) {
		return "#" + this.toHex(e);
	},
	toHex8: function(e) {
		return d(this._r, this._g, this._b, this._a, e);
	},
	toHex8String: function(e) {
		return "#" + this.toHex8(e);
	},
	toRgb: function() {
		return {
			r: Math.round(this._r),
			g: Math.round(this._g),
			b: Math.round(this._b),
			a: this._a
		};
	},
	toRgbString: function() {
		return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
	},
	toPercentageRgb: function() {
		return {
			r: Math.round(k(this._r, 255) * 100) + "%",
			g: Math.round(k(this._g, 255) * 100) + "%",
			b: Math.round(k(this._b, 255) * 100) + "%",
			a: this._a
		};
	},
	toPercentageRgbString: function() {
		return this._a == 1 ? "rgb(" + Math.round(k(this._r, 255) * 100) + "%, " + Math.round(k(this._g, 255) * 100) + "%, " + Math.round(k(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(k(this._r, 255) * 100) + "%, " + Math.round(k(this._g, 255) * 100) + "%, " + Math.round(k(this._b, 255) * 100) + "%, " + this._roundA + ")";
	},
	toName: function() {
		return this._a === 0 ? "transparent" : this._a < 1 ? !1 : E[u(this._r, this._g, this._b, !0)] || !1;
	},
	toFilter: function(e) {
		var t = "#" + f(this._r, this._g, this._b, this._a), n = t, i = this._gradientType ? "GradientType = 1, " : "";
		if (e) {
			var a = r(e);
			n = "#" + f(a._r, a._g, a._b, a._a);
		}
		return "progid:DXImageTransform.Microsoft.gradient(" + i + "startColorstr=" + t + ",endColorstr=" + n + ")";
	},
	toString: function(e) {
		var t = !!e;
		e ||= this._format;
		var n = !1, r = this._a < 1 && this._a >= 0;
		return !t && r && (e === "hex" || e === "hex6" || e === "hex3" || e === "hex4" || e === "hex8" || e === "name") ? e === "name" && this._a === 0 ? this.toName() : this.toRgbString() : (e === "rgb" && (n = this.toRgbString()), e === "prgb" && (n = this.toPercentageRgbString()), (e === "hex" || e === "hex6") && (n = this.toHexString()), e === "hex3" && (n = this.toHexString(!0)), e === "hex4" && (n = this.toHex8String(!0)), e === "hex8" && (n = this.toHex8String()), e === "name" && (n = this.toName()), e === "hsl" && (n = this.toHslString()), e === "hsv" && (n = this.toHsvString()), n || this.toHexString());
	},
	clone: function() {
		return r(this.toString());
	},
	_applyModification: function(e, t) {
		var n = e.apply(null, [this].concat([].slice.call(t)));
		return this._r = n._r, this._g = n._g, this._b = n._b, this.setAlpha(n._a), this;
	},
	lighten: function() {
		return this._applyModification(g, arguments);
	},
	brighten: function() {
		return this._applyModification(_, arguments);
	},
	darken: function() {
		return this._applyModification(v, arguments);
	},
	desaturate: function() {
		return this._applyModification(p, arguments);
	},
	saturate: function() {
		return this._applyModification(m, arguments);
	},
	greyscale: function() {
		return this._applyModification(h, arguments);
	},
	spin: function() {
		return this._applyModification(y, arguments);
	},
	_applyCombination: function(e, t) {
		return e.apply(null, [this].concat([].slice.call(t)));
	},
	analogous: function() {
		return this._applyCombination(C, arguments);
	},
	complement: function() {
		return this._applyCombination(b, arguments);
	},
	monochromatic: function() {
		return this._applyCombination(w, arguments);
	},
	splitcomplement: function() {
		return this._applyCombination(S, arguments);
	},
	triad: function() {
		return this._applyCombination(x, [3]);
	},
	tetrad: function() {
		return this._applyCombination(x, [4]);
	}
}, r.fromRatio = function(t, n) {
	if (e(t) == "object") {
		var i = {};
		for (var a in t) t.hasOwnProperty(a) && (a === "a" ? i[a] = t[a] : i[a] = F(t[a]));
		t = i;
	}
	return r(t, n);
};
function i(t) {
	var n = {
		r: 0,
		g: 0,
		b: 0
	}, r = 1, i = null, o = null, c = null, u = !1, d = !1;
	return typeof t == "string" && (t = B(t)), e(t) == "object" && (z(t.r) && z(t.g) && z(t.b) ? (n = a(t.r, t.g, t.b), u = !0, d = String(t.r).substr(-1) === "%" ? "prgb" : "rgb") : z(t.h) && z(t.s) && z(t.v) ? (i = F(t.s), o = F(t.v), n = l(t.h, i, o), u = !0, d = "hsv") : z(t.h) && z(t.s) && z(t.l) && (i = F(t.s), c = F(t.l), n = s(t.h, i, c), u = !0, d = "hsl"), t.hasOwnProperty("a") && (r = t.a)), r = O(r), {
		ok: u,
		format: t.format || d,
		r: Math.min(255, Math.max(n.r, 0)),
		g: Math.min(255, Math.max(n.g, 0)),
		b: Math.min(255, Math.max(n.b, 0)),
		a: r
	};
}
function a(e, t, n) {
	return {
		r: k(e, 255) * 255,
		g: k(t, 255) * 255,
		b: k(n, 255) * 255
	};
}
function o(e, t, n) {
	e = k(e, 255), t = k(t, 255), n = k(n, 255);
	var r = Math.max(e, t, n), i = Math.min(e, t, n), a, o, s = (r + i) / 2;
	if (r == i) a = o = 0;
	else {
		var c = r - i;
		switch (o = s > .5 ? c / (2 - r - i) : c / (r + i), r) {
			case e:
				a = (t - n) / c + (t < n ? 6 : 0);
				break;
			case t:
				a = (n - e) / c + 2;
				break;
			case n:
				a = (e - t) / c + 4;
				break;
		}
		a /= 6;
	}
	return {
		h: a,
		s: o,
		l: s
	};
}
function s(e, t, n) {
	var r, i, a;
	e = k(e, 360), t = k(t, 100), n = k(n, 100);
	function o(e, t, n) {
		return n < 0 && (n += 1), n > 1 && --n, n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
	}
	if (t === 0) r = i = a = n;
	else {
		var s = n < .5 ? n * (1 + t) : n + t - n * t, c = 2 * n - s;
		r = o(c, s, e + 1 / 3), i = o(c, s, e), a = o(c, s, e - 1 / 3);
	}
	return {
		r: r * 255,
		g: i * 255,
		b: a * 255
	};
}
function c(e, t, n) {
	e = k(e, 255), t = k(t, 255), n = k(n, 255);
	var r = Math.max(e, t, n), i = Math.min(e, t, n), a, o, s = r, c = r - i;
	if (o = r === 0 ? 0 : c / r, r == i) a = 0;
	else {
		switch (r) {
			case e:
				a = (t - n) / c + (t < n ? 6 : 0);
				break;
			case t:
				a = (n - e) / c + 2;
				break;
			case n:
				a = (e - t) / c + 4;
				break;
		}
		a /= 6;
	}
	return {
		h: a,
		s: o,
		v: s
	};
}
function l(e, t, n) {
	e = k(e, 360) * 6, t = k(t, 100), n = k(n, 100);
	var r = Math.floor(e), i = e - r, a = n * (1 - t), o = n * (1 - i * t), s = n * (1 - (1 - i) * t), c = r % 6, l = [
		n,
		o,
		a,
		a,
		s,
		n
	][c], u = [
		s,
		n,
		n,
		o,
		a,
		a
	][c], d = [
		a,
		a,
		s,
		n,
		n,
		o
	][c];
	return {
		r: l * 255,
		g: u * 255,
		b: d * 255
	};
}
function u(e, t, n, r) {
	var i = [
		P(Math.round(e).toString(16)),
		P(Math.round(t).toString(16)),
		P(Math.round(n).toString(16))
	];
	return r && i[0].charAt(0) == i[0].charAt(1) && i[1].charAt(0) == i[1].charAt(1) && i[2].charAt(0) == i[2].charAt(1) ? i[0].charAt(0) + i[1].charAt(0) + i[2].charAt(0) : i.join("");
}
function d(e, t, n, r, i) {
	var a = [
		P(Math.round(e).toString(16)),
		P(Math.round(t).toString(16)),
		P(Math.round(n).toString(16)),
		P(I(r))
	];
	return i && a[0].charAt(0) == a[0].charAt(1) && a[1].charAt(0) == a[1].charAt(1) && a[2].charAt(0) == a[2].charAt(1) && a[3].charAt(0) == a[3].charAt(1) ? a[0].charAt(0) + a[1].charAt(0) + a[2].charAt(0) + a[3].charAt(0) : a.join("");
}
function f(e, t, n, r) {
	return [
		P(I(r)),
		P(Math.round(e).toString(16)),
		P(Math.round(t).toString(16)),
		P(Math.round(n).toString(16))
	].join("");
}
r.equals = function(e, t) {
	return !e || !t ? !1 : r(e).toRgbString() == r(t).toRgbString();
}, r.random = function() {
	return r.fromRatio({
		r: Math.random(),
		g: Math.random(),
		b: Math.random()
	});
};
function p(e, t) {
	t = t === 0 ? 0 : t || 10;
	var n = r(e).toHsl();
	return n.s -= t / 100, n.s = A(n.s), r(n);
}
function m(e, t) {
	t = t === 0 ? 0 : t || 10;
	var n = r(e).toHsl();
	return n.s += t / 100, n.s = A(n.s), r(n);
}
function h(e) {
	return r(e).desaturate(100);
}
function g(e, t) {
	t = t === 0 ? 0 : t || 10;
	var n = r(e).toHsl();
	return n.l += t / 100, n.l = A(n.l), r(n);
}
function _(e, t) {
	t = t === 0 ? 0 : t || 10;
	var n = r(e).toRgb();
	return n.r = Math.max(0, Math.min(255, n.r - Math.round(255 * -(t / 100)))), n.g = Math.max(0, Math.min(255, n.g - Math.round(255 * -(t / 100)))), n.b = Math.max(0, Math.min(255, n.b - Math.round(255 * -(t / 100)))), r(n);
}
function v(e, t) {
	t = t === 0 ? 0 : t || 10;
	var n = r(e).toHsl();
	return n.l -= t / 100, n.l = A(n.l), r(n);
}
function y(e, t) {
	var n = r(e).toHsl(), i = (n.h + t) % 360;
	return n.h = i < 0 ? 360 + i : i, r(n);
}
function b(e) {
	var t = r(e).toHsl();
	return t.h = (t.h + 180) % 360, r(t);
}
function x(e, t) {
	if (isNaN(t) || t <= 0) throw Error("Argument to polyad must be a positive number");
	for (var n = r(e).toHsl(), i = [r(e)], a = 360 / t, o = 1; o < t; o++) i.push(r({
		h: (n.h + o * a) % 360,
		s: n.s,
		l: n.l
	}));
	return i;
}
function S(e) {
	var t = r(e).toHsl(), n = t.h;
	return [
		r(e),
		r({
			h: (n + 72) % 360,
			s: t.s,
			l: t.l
		}),
		r({
			h: (n + 216) % 360,
			s: t.s,
			l: t.l
		})
	];
}
function C(e, t, n) {
	t ||= 6, n ||= 30;
	var i = r(e).toHsl(), a = 360 / n, o = [r(e)];
	for (i.h = (i.h - (a * t >> 1) + 720) % 360; --t;) i.h = (i.h + a) % 360, o.push(r(i));
	return o;
}
function w(e, t) {
	t ||= 6;
	for (var n = r(e).toHsv(), i = n.h, a = n.s, o = n.v, s = [], c = 1 / t; t--;) s.push(r({
		h: i,
		s: a,
		v: o
	})), o = (o + c) % 1;
	return s;
}
r.mix = function(e, t, n) {
	n = n === 0 ? 0 : n || 50;
	var i = r(e).toRgb(), a = r(t).toRgb(), o = n / 100;
	return r({
		r: (a.r - i.r) * o + i.r,
		g: (a.g - i.g) * o + i.g,
		b: (a.b - i.b) * o + i.b,
		a: (a.a - i.a) * o + i.a
	});
}, r.readability = function(e, t) {
	var n = r(e), i = r(t);
	return (Math.max(n.getLuminance(), i.getLuminance()) + .05) / (Math.min(n.getLuminance(), i.getLuminance()) + .05);
}, r.isReadable = function(e, t, n) {
	var i = r.readability(e, t), a, o = !1;
	switch (a = V(n), a.level + a.size) {
		case "AAsmall":
		case "AAAlarge":
			o = i >= 4.5;
			break;
		case "AAlarge":
			o = i >= 3;
			break;
		case "AAAsmall":
			o = i >= 7;
			break;
	}
	return o;
}, r.mostReadable = function(e, t, n) {
	var i = null, a = 0, o, s, c, l;
	n ||= {}, s = n.includeFallbackColors, c = n.level, l = n.size;
	for (var u = 0; u < t.length; u++) o = r.readability(e, t[u]), o > a && (a = o, i = r(t[u]));
	return r.isReadable(e, i, {
		level: c,
		size: l
	}) || !s ? i : (n.includeFallbackColors = !1, r.mostReadable(e, ["#fff", "#000"], n));
};
var T = r.names = {
	aliceblue: "f0f8ff",
	antiquewhite: "faebd7",
	aqua: "0ff",
	aquamarine: "7fffd4",
	azure: "f0ffff",
	beige: "f5f5dc",
	bisque: "ffe4c4",
	black: "000",
	blanchedalmond: "ffebcd",
	blue: "00f",
	blueviolet: "8a2be2",
	brown: "a52a2a",
	burlywood: "deb887",
	burntsienna: "ea7e5d",
	cadetblue: "5f9ea0",
	chartreuse: "7fff00",
	chocolate: "d2691e",
	coral: "ff7f50",
	cornflowerblue: "6495ed",
	cornsilk: "fff8dc",
	crimson: "dc143c",
	cyan: "0ff",
	darkblue: "00008b",
	darkcyan: "008b8b",
	darkgoldenrod: "b8860b",
	darkgray: "a9a9a9",
	darkgreen: "006400",
	darkgrey: "a9a9a9",
	darkkhaki: "bdb76b",
	darkmagenta: "8b008b",
	darkolivegreen: "556b2f",
	darkorange: "ff8c00",
	darkorchid: "9932cc",
	darkred: "8b0000",
	darksalmon: "e9967a",
	darkseagreen: "8fbc8f",
	darkslateblue: "483d8b",
	darkslategray: "2f4f4f",
	darkslategrey: "2f4f4f",
	darkturquoise: "00ced1",
	darkviolet: "9400d3",
	deeppink: "ff1493",
	deepskyblue: "00bfff",
	dimgray: "696969",
	dimgrey: "696969",
	dodgerblue: "1e90ff",
	firebrick: "b22222",
	floralwhite: "fffaf0",
	forestgreen: "228b22",
	fuchsia: "f0f",
	gainsboro: "dcdcdc",
	ghostwhite: "f8f8ff",
	gold: "ffd700",
	goldenrod: "daa520",
	gray: "808080",
	green: "008000",
	greenyellow: "adff2f",
	grey: "808080",
	honeydew: "f0fff0",
	hotpink: "ff69b4",
	indianred: "cd5c5c",
	indigo: "4b0082",
	ivory: "fffff0",
	khaki: "f0e68c",
	lavender: "e6e6fa",
	lavenderblush: "fff0f5",
	lawngreen: "7cfc00",
	lemonchiffon: "fffacd",
	lightblue: "add8e6",
	lightcoral: "f08080",
	lightcyan: "e0ffff",
	lightgoldenrodyellow: "fafad2",
	lightgray: "d3d3d3",
	lightgreen: "90ee90",
	lightgrey: "d3d3d3",
	lightpink: "ffb6c1",
	lightsalmon: "ffa07a",
	lightseagreen: "20b2aa",
	lightskyblue: "87cefa",
	lightslategray: "789",
	lightslategrey: "789",
	lightsteelblue: "b0c4de",
	lightyellow: "ffffe0",
	lime: "0f0",
	limegreen: "32cd32",
	linen: "faf0e6",
	magenta: "f0f",
	maroon: "800000",
	mediumaquamarine: "66cdaa",
	mediumblue: "0000cd",
	mediumorchid: "ba55d3",
	mediumpurple: "9370db",
	mediumseagreen: "3cb371",
	mediumslateblue: "7b68ee",
	mediumspringgreen: "00fa9a",
	mediumturquoise: "48d1cc",
	mediumvioletred: "c71585",
	midnightblue: "191970",
	mintcream: "f5fffa",
	mistyrose: "ffe4e1",
	moccasin: "ffe4b5",
	navajowhite: "ffdead",
	navy: "000080",
	oldlace: "fdf5e6",
	olive: "808000",
	olivedrab: "6b8e23",
	orange: "ffa500",
	orangered: "ff4500",
	orchid: "da70d6",
	palegoldenrod: "eee8aa",
	palegreen: "98fb98",
	paleturquoise: "afeeee",
	palevioletred: "db7093",
	papayawhip: "ffefd5",
	peachpuff: "ffdab9",
	peru: "cd853f",
	pink: "ffc0cb",
	plum: "dda0dd",
	powderblue: "b0e0e6",
	purple: "800080",
	rebeccapurple: "663399",
	red: "f00",
	rosybrown: "bc8f8f",
	royalblue: "4169e1",
	saddlebrown: "8b4513",
	salmon: "fa8072",
	sandybrown: "f4a460",
	seagreen: "2e8b57",
	seashell: "fff5ee",
	sienna: "a0522d",
	silver: "c0c0c0",
	skyblue: "87ceeb",
	slateblue: "6a5acd",
	slategray: "708090",
	slategrey: "708090",
	snow: "fffafa",
	springgreen: "00ff7f",
	steelblue: "4682b4",
	tan: "d2b48c",
	teal: "008080",
	thistle: "d8bfd8",
	tomato: "ff6347",
	turquoise: "40e0d0",
	violet: "ee82ee",
	wheat: "f5deb3",
	white: "fff",
	whitesmoke: "f5f5f5",
	yellow: "ff0",
	yellowgreen: "9acd32"
}, E = r.hexNames = D(T);
function D(e) {
	var t = {};
	for (var n in e) e.hasOwnProperty(n) && (t[e[n]] = n);
	return t;
}
function O(e) {
	return e = parseFloat(e), (isNaN(e) || e < 0 || e > 1) && (e = 1), e;
}
function k(e, t) {
	M(e) && (e = "100%");
	var n = N(e);
	return e = Math.min(t, Math.max(0, parseFloat(e))), n && (e = parseInt(e * t, 10) / 100), Math.abs(e - t) < 1e-6 ? 1 : e % t / parseFloat(t);
}
function A(e) {
	return Math.min(1, Math.max(0, e));
}
function j(e) {
	return parseInt(e, 16);
}
function M(e) {
	return typeof e == "string" && e.indexOf(".") != -1 && parseFloat(e) === 1;
}
function N(e) {
	return typeof e == "string" && e.indexOf("%") != -1;
}
function P(e) {
	return e.length == 1 ? "0" + e : "" + e;
}
function F(e) {
	return e <= 1 && (e = e * 100 + "%"), e;
}
function I(e) {
	return Math.round(parseFloat(e) * 255).toString(16);
}
function L(e) {
	return j(e) / 255;
}
var R = function() {
	var e = "(?:[-\\+]?\\d*\\.\\d+%?)|(?:[-\\+]?\\d+%?)", t = "[\\s|\\(]+(" + e + ")[,|\\s]+(" + e + ")[,|\\s]+(" + e + ")\\s*\\)?", n = "[\\s|\\(]+(" + e + ")[,|\\s]+(" + e + ")[,|\\s]+(" + e + ")[,|\\s]+(" + e + ")\\s*\\)?";
	return {
		CSS_UNIT: new RegExp(e),
		rgb: RegExp("rgb" + t),
		rgba: RegExp("rgba" + n),
		hsl: RegExp("hsl" + t),
		hsla: RegExp("hsla" + n),
		hsv: RegExp("hsv" + t),
		hsva: RegExp("hsva" + n),
		hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
		hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
		hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
		hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
	};
}();
function z(e) {
	return !!R.CSS_UNIT.exec(e);
}
function B(e) {
	e = e.replace(t, "").replace(n, "").toLowerCase();
	var r = !1;
	if (T[e]) e = T[e], r = !0;
	else if (e == "transparent") return {
		r: 0,
		g: 0,
		b: 0,
		a: 0,
		format: "name"
	};
	var i;
	return (i = R.rgb.exec(e)) ? {
		r: i[1],
		g: i[2],
		b: i[3]
	} : (i = R.rgba.exec(e)) ? {
		r: i[1],
		g: i[2],
		b: i[3],
		a: i[4]
	} : (i = R.hsl.exec(e)) ? {
		h: i[1],
		s: i[2],
		l: i[3]
	} : (i = R.hsla.exec(e)) ? {
		h: i[1],
		s: i[2],
		l: i[3],
		a: i[4]
	} : (i = R.hsv.exec(e)) ? {
		h: i[1],
		s: i[2],
		v: i[3]
	} : (i = R.hsva.exec(e)) ? {
		h: i[1],
		s: i[2],
		v: i[3],
		a: i[4]
	} : (i = R.hex8.exec(e)) ? {
		r: j(i[1]),
		g: j(i[2]),
		b: j(i[3]),
		a: L(i[4]),
		format: r ? "name" : "hex8"
	} : (i = R.hex6.exec(e)) ? {
		r: j(i[1]),
		g: j(i[2]),
		b: j(i[3]),
		format: r ? "name" : "hex"
	} : (i = R.hex4.exec(e)) ? {
		r: j(i[1] + "" + i[1]),
		g: j(i[2] + "" + i[2]),
		b: j(i[3] + "" + i[3]),
		a: L(i[4] + "" + i[4]),
		format: r ? "name" : "hex8"
	} : (i = R.hex3.exec(e)) ? {
		r: j(i[1] + "" + i[1]),
		g: j(i[2] + "" + i[2]),
		b: j(i[3] + "" + i[3]),
		format: r ? "name" : "hex"
	} : !1;
}
function V(e) {
	var t, n;
	return e ||= {
		level: "AA",
		size: "small"
	}, t = (e.level || "AA").toUpperCase(), n = (e.size || "small").toLowerCase(), t !== "AA" && t !== "AAA" && (t = "AA"), n !== "small" && n !== "large" && (n = "small"), {
		level: t,
		size: n
	};
}
//#endregion
export { r as tinycolor };
